export const API_URL = process.env.REACT_APP_BACKEND_URL
const endpoints = {
  // Auth
  SIGN_IN: API_URL + "/api/v1/auth/signin",
  PROFILE: (userId: any) => API_URL + `/api/v1/users/${userId}`,
  FORGOT_PASSWORD: API_URL + "/api/v1/auth/forgot-password",
  RESET_PASSWORD: API_URL + "/api/v1/auth/reset-password",
  EDIT_PROFILE: (userId: any) => API_URL + `/api/v1/users/${userId}`,
  CHANGE_PASSWORD: API_URL + "/api/v1/users/change-password",

  // Role
  VIEW_LIST_ROLE: API_URL + "/api/v1/roles",

  // Project
  PROJECT: API_URL + "/api/v1/projects",

  CLIENT: API_URL + "/api/v1/clients",
  
  // Contract
  CONTRACT: API_URL + "/api/v1/contract",
  CONTRACT_DOWNLOAD: API_URL + "/api/v1/contract/download",
  CONTRACT_RESPOND: API_URL + "/api/v1/contract/respond",
  GET_EMPLOYEE_CONTRACT: (id: any) => API_URL + `/api/v1/contract/employee/${id}`,
  CONTRACT_HISTORY: (id: any) => API_URL + `/api/v1/contract/${id}/history`,
  HISTORY_DOCUMENT_DOWNLOAD: (id: any) => API_URL + `/api/v1/contract/history/${id}/download`,
  CONTRACT_TEMPLATE: API_URL + "/api/v1/contract/template",
  CONTRACT_PUBLIC_REVIEW: (token: string) => API_URL + `/api/v1/contract/public/${token}`,
  CONTRACT_PUBLIC_SIGN: (token: string) =>
    API_URL + `/api/v1/contract/public/${token}/sign`,
  CONTRACT_PUBLIC_REJECT: (token: string) =>
    API_URL + `/api/v1/contract/public/${token}/reject`,
  CONTRACT_RESEND_REVIEW_LINK: (id: any) => API_URL + `/api/v1/contract/${id}/resend-review-link`,

  // Contact US
  CONTACT_US_LIST: API_URL + "/api/v1/help-center/contact-us",
  VIEW_CONTACT: (viewId: any) => API_URL + `/api/v1/help-center/contact-us/${viewId}`,

  // Users
  USERS: API_URL + "/api/v1/users",
  SEARCH_LIST_USER: API_URL + "/api/v1/admin/search-users",
  CREATE_USER: API_URL + "/api/v1/users",
  VIEW_USER: (viewId: any) => API_URL + `/api/v1/users/${viewId}`,
};

export default endpoints;
